// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1sDIE","title":"Info_title__23wgr","links":"Info_links__w32Cc","link":"Info_link__uTmTv","logo":"Info_logo__3yQWW"};